const str = `{HEADER}AI利用規約

{BODY_TITLE}第1条 (目的)
この規約は、ビデオモンスターサービス内で提供されるAI基盤の機能および結果物に関して適用され、既存の利用規約および著作権ポリシーに追加適用されます。 利用者は、ビデオモンスターサービスで提供されるAIサービスを利用する前に、本規約および利用規約の制限ポリシーを確認し、遵守する責任があります。 本規約は、会社によって随時更新される場合があります。

{BODY_TITLE}第2条 (用語の定義)
本規約で使用する用語の定義は以下の通りです。
1) AI機能：ビデオモンスターが提供するテキスト、画像、動画機能などAI基盤のすべての機能を意味します。
2) AI生成物：ビデオモンスターサービス内でAI機能を通じて提供および加工されたテキスト、画像、動画を意味します。
3) 技術パートナー：ビデオモンスターがAI機能を提供するために利用している第三者サービス提供業者を意味します。

{BODY_TITLE}第3条 (利用の制限)
利用規約で禁止されている事項に加えて、以下のようにAI生成物を使用することを禁止しています。
1) AI生成物を人間が生成したように欺いたり、誤解を招くように表現して使用することはできません。
2) AI生成物を利用者自身が創作したように表現して使用することはできません。
3) AI生成物が猥褻であったり、わいせつで公序良俗に反する場合、使用することはできません。
4) AI生成物が他人の権利（個人情報、肖像権、パブリシティ権など）を侵害したり、他人を誹謗中傷する場合、使用することはできません。
5) AI生成物が医学的結果として誤解される可能性がある場合、使用することはできません。
6) AI生成物を販売することはできません。

{BODY_TITLE}第4条 (利用者の権利および義務)
1) 利用者は、AI機能を利用するために入力した内容に対する責任があり、AI結果物に対する著作権は会社や利用者にはなく、権利を主張することはできません。
2) 本規約を遵守せずにAI結果物を使用して発生する法的責任は利用者にあります。
3) 利用者は、機械学習モデルまたは関連技術を開発するためにAI結果物を使用することはできません。
4) 利用者がAI結果物を共有および投稿する際、該当結果物がAIによって生成されたことを明確に表示することを推奨します。

{BODY_TITLE}第5条 (会社の権利および義務)
1) 会社は、利用者が生成AI結果物を使用する際に発生する紛争や被害について責任を負いません。
2) 会社が提供する生成AI結果物は人工知能によって生成されており、当社は生成AI結果物の正確性、信頼性および代表性について一切の保証や保障を提供しません。
3) 会社は、利用者が入力したテキストまたは利用者が生成した結果物に対して著作権を主張しません。
4) 会社は、利用者の生成AI結果物をサービス改善のために活用したり、マーケティングおよび広報目的で使用することができます。

{BODY_TITLE}第6条 (技術パートナー)
1) 会社は、生成AI基盤のサービスを提供するために第三者サービス提供業者が提供する技術モデルを使用しています。
2) 利用者がAI機能利用のために入力したデータの一部が第三者サービス提供業者と共有される場合があり、第三者提供業者はこのようなデータを自社のサービス改善に使用することができます。
3) 第三者サービス提供業者に共有されるデータには利用者の個人情報が含まれる可能性があり、利用者は当社の個人情報処理方針が該当個人情報処理に適用されることに同意します。
4)第三者サービス提供業者のポリシーにより、利用者が居住する国によって個人情報保護レベルが同一でない場合があります。
- 第三者サービス提供業者 : Open AI, LLC
- 共有データ : 利用者が入力したテキスト

- 第三者サービス提供業者 : Stability AI
- 共有データ : 利用者が入力した画像、テキスト

{FOOTER_SUB}告知日：2024年10月18日
{FOOTER_SUB_2}施行日：2024年11月1日
`

export default str